import React, { Component } from 'react'
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column'
import {Button} from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import classNames from 'classnames';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { CiteService } from '../../service/CiteService';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactLoading from 'react-loading';
import { ParametrePaiementService } from '../../service/ParametrePaiementService';
import { SessionService } from '../../service/SessionService';
import { messageErreur } from '../../service/MessageErreur';


export class ParametrePaiement extends Component {
    emptyParametrePaiement = {
        idParametrePaiementCite : 0,
        idCite : 0,
        nomCite : "",
        dureeOccupationMois : "",
        cautionMois : "",
        loyerPremierVersementMois : "",
        nombreEcheancesReste : "",
        dateDebutOccupation : null,
        idAnnee : null
    };
    constructor() {
        super();
        this.state = {

            listeCite : [],
            listeParametre : [],
            listeAnnee : [],
            idAnneeFiltre : null,
            listeCategorieChambre : [],
            parametrePaiementDialog: false,
            parametrePaiement: this.emptyParametrePaiement,
            submitted: false,
            loading : false,
            enregistrement : false,
            globalFilter: null,

            apercuDialog : false,
            apercuCite : null,
            apercuIdCategorieChambre : null,
            apercu : null,
            apercuCategories : null,
            apercuLoading : false,
            datesDialog : false,
            datesLimites : [],
            enregistrementDates : false,
            categoriesChargees : false
        }

        this.parametrePaiementService = new ParametrePaiementService();
        this.citeService = new CiteService();
        this.sessionService = new SessionService();

        this.actionBodyTemplate = this.actionBodyTemplate.bind(this);
        this.moisRestantBodyTemplate = this.moisRestantBodyTemplate.bind(this);
        this.hideDialog = this.hideDialog.bind(this);
        this.saveParametrePaiement = this.saveParametrePaiement.bind(this);
        this.editParametrePaiement = this.editParametrePaiement.bind(this);
        this.onChampChange = this.onChampChange.bind(this);
        this.loadDonnees = this.loadDonnees.bind(this);
        this.ouvrirApercu = this.ouvrirApercu.bind(this);
        this.hideApercuDialog = this.hideApercuDialog.bind(this);
        this.chargerApercu = this.chargerApercu.bind(this);
        this.ouvrirEditionDates = this.ouvrirEditionDates.bind(this);
        this.enregistrerDatesLimites = this.enregistrerDatesLimites.bind(this);
    }
    componentDidMount() {
        const data = localStorage.getItem('user')
        const user = data ? JSON.parse(data) : {}
        const requeteSession = user.idDirection
            ? this.sessionService.getSessionDirection(user.idDirection)
            : this.sessionService.getAll();

        // les années académiques viennent des sessions : pas d'entité année côté API
        requeteSession.then(data => {
            const sessions = Array.isArray(data) ? data : [];
            const annees = [];
            sessions.forEach(session => {
                if (session.idAnnee && annees.indexOf(session.idAnnee) === -1) {
                    annees.push(session.idAnnee);
                }
            });
            annees.sort((a, b) => b - a);
            this.setState({
                listeAnnee : annees.map(idAnnee => ({idAnnee : idAnnee, libelleAnnee : String(idAnnee)})),
                idAnneeFiltre : annees.length ? annees[0] : null
            }, this.loadDonnees);
        })
        .catch(error => {
            console.log(error)
            this.loadDonnees()
        })
    }

    loadDonnees() {
        this.setState({loading : true})
        this.citeService.getAll().then(data => {
            this.setState({listeCite: data, loading : false})
        })
        .catch(error => {
            this.notify2("Impossible de charger les cités.")
            console.log(error)
            this.setState({loading : false})
        })

        this.parametrePaiementService.getAll(this.state.idAnneeFiltre).then(data => {
            this.setState({listeParametre : Array.isArray(data) ? data : []})
        })
        .catch(error => {
            console.log(error)
            this.setState({listeParametre : []})
        })
    }

    /* Une ligne par cité : le paramétrage existant si présent, sinon des champs vides. */
    getLignes() {
        return this.state.listeCite.map(cite => {
            // un paramètre sans idAnnee vient d'avant le découpage par année : on le garde
            const parametre = this.state.listeParametre.find(p =>
                p.idCite === cite.idCite &&
                (!this.state.idAnneeFiltre || !p.idAnnee || p.idAnnee === this.state.idAnneeFiltre)
            );
            if (parametre) {
                return { ...parametre, idCite : cite.idCite, nomCite : cite.nomCite, parametre : true };
            }
            return { ...this.emptyParametrePaiement, idCite : cite.idCite, nomCite : cite.nomCite, parametre : false };
        });
    }

    /* Le serveur recalcule la même valeur ; on l'affiche en direct pendant la saisie. */
    getResteAPayerMois(parametrePaiement) {
        const occupation = parseInt(parametrePaiement.dureeOccupationMois);
        const premierVersement = parseInt(parametrePaiement.loyerPremierVersementMois);
        if (isNaN(occupation) || isNaN(premierVersement)) {
            return null;
        }
        return occupation - premierVersement;
    }

    hideDialog() {
        this.setState({
            submitted: false,
            parametrePaiementDialog: false
        });
    }
    editParametrePaiement(rowData) {
        this.setState({
            parametrePaiement : {
                idParametrePaiementCite : rowData.idParametrePaiementCite,
                idCite : rowData.idCite,
                nomCite : rowData.nomCite,
                dureeOccupationMois : rowData.dureeOccupationMois,
                cautionMois : rowData.cautionMois,
                loyerPremierVersementMois : rowData.loyerPremierVersementMois,
                nombreEcheancesReste : rowData.nombreEcheancesReste,
                dateDebutOccupation : this.parseDateApi(rowData.dateDebutOccupation),
                idAnnee : rowData.idAnnee || this.state.idAnneeFiltre
            },
            listeCategorieChambre : [],
            submitted: false,
            parametrePaiementDialog: true
        });

        // les prix servent à montrer les montants qui découlent du paramétrage
        this.citeService.getCategorieChambreCite(rowData.idCite, rowData.nomCite).then(liste => {
            this.setState({listeCategorieChambre : liste})
        })
        .catch(error => {
            console.log(error)
            this.setState({listeCategorieChambre : []})
        })
    }

    /* Renvoie un message d'erreur, ou null si le paramétrage est cohérent. */
    getErreurValidation() {
        const parametrePaiement = this.state.parametrePaiement;
        const occupation = parseInt(parametrePaiement.dureeOccupationMois);
        const caution = parseInt(parametrePaiement.cautionMois);
        const premierVersement = parseInt(parametrePaiement.loyerPremierVersementMois);
        const echeance = parseInt(parametrePaiement.nombreEcheancesReste);

        if (!parametrePaiement.idAnnee) {
            return "L'année académique est obligatoire.";
        }
        if (isNaN(occupation) || occupation < 1) {
            return "La durée d'occupation doit être d'au moins 1 mois.";
        }
        if (isNaN(caution) || caution < 0) {
            return "Le nombre de mois de caution est obligatoire.";
        }
        if (isNaN(premierVersement) || premierVersement < 0) {
            return "Le nombre de mois de loyer du 1er versement est obligatoire.";
        }
        if (premierVersement > occupation) {
            return "Le 1er versement ne peut pas dépasser la durée d'occupation (" + occupation + " mois).";
        }
        const reste = occupation - premierVersement;
        if (reste === 0) {
            return null;
        }
        if (isNaN(echeance) || echeance < 1) {
            return "Le nombre d'échéances pour le reste est obligatoire.";
        }
        if (echeance > reste) {
            return "Le nombre d'échéances ne peut pas dépasser les " + reste + " mois restants.";
        }
        return null;
    }

    saveParametrePaiement() {
        if (this.getErreurValidation()) {
            this.setState({ submitted: true });
            return;
        }

        const parametrePaiement = this.state.parametrePaiement;
        const reste = this.getResteAPayerMois(parametrePaiement);
        // resteAPayerMois n'est pas envoyé : il est calculé côté serveur
        const newParametrePaiement = {
            idCite : parseInt(parametrePaiement.idCite) ,
            idAnnee : parseInt(parametrePaiement.idAnnee) ,
            dureeOccupationMois : parseInt(parametrePaiement.dureeOccupationMois) ,
            cautionMois : parseInt(parametrePaiement.cautionMois) ,
            loyerPremierVersementMois : parseInt(parametrePaiement.loyerPremierVersementMois) ,
            nombreEcheancesReste : reste === 0 ? 0 : parseInt(parametrePaiement.nombreEcheancesReste)
        }
        // champ optionnel : on ne l'envoie que s'il est renseigné
        if (parametrePaiement.dateDebutOccupation) {
            newParametrePaiement.dateDebutOccupation = this.formatDateApi(parametrePaiement.dateDebutOccupation);
        }

        this.setState({ submitted : true, enregistrement : true });

        const idParametre = parseInt(parametrePaiement.idParametrePaiementCite);
        const requete = idParametre
            ? this.parametrePaiementService.update(idParametre, newParametrePaiement)
            : this.parametrePaiementService.create(newParametrePaiement);

        requete.then(data => {
            this.terminerEnregistrement();
        })
        .catch(error => {
            console.log(error);
            // 409 : un paramètre actif existe déjà pour cette cité, on bascule en modification
            if (!idParametre && error.response && error.response.status === 409) {
                this.parametrePaiementService.getParametreCite(newParametrePaiement.idCite, newParametrePaiement.idAnnee)
                    .then(parametreExistant => {
                        return this.parametrePaiementService.update(parametreExistant.idParametrePaiementCite, newParametrePaiement)
                    })
                    .then(data => { this.terminerEnregistrement(); })
                    .catch(erreurUpdate => {
                        console.log(erreurUpdate);
                        this.echecEnregistrement(erreurUpdate);
                    })
                return;
            }
            this.echecEnregistrement(error);
        })
    }

    terminerEnregistrement() {
        this.notify();
        this.loadDonnees();
        this.setState({
            enregistrement : false,
            parametrePaiementDialog: false,
            parametrePaiement: this.emptyParametrePaiement
        });
    }
    echecEnregistrement(error) {
        const statut = error.response ? error.response.status : null;
        if (statut === 400) this.notify2("Paramétrage refusé par le serveur : vérifiez les valeurs saisies.");
        else if (statut === 404) this.notify2("Cité ou paramétrage introuvable.");
        else this.notify2("Echec de l'enregistrement.");
        this.setState({ enregistrement : false });
    }

    onChampChange(e, champ) {
        const val = (e.target && e.target.value) || '';
        // ces champs sont tous des nombres de mois / d'échéances
        if (val && !/^\d+$/.test(val)) {
            return;
        }
        this.setState({ parametrePaiement : { ...this.state.parametrePaiement, [champ] : val } });
    }

    /* Les dates de l'API sont au format dd-MM-yyyy. */
    parseDateApi(valeur) {
        if (!valeur) {
            return null;
        }
        const morceaux = String(valeur).split('-');
        if (morceaux.length !== 3) {
            return null;
        }
        return new Date(parseInt(morceaux[2]), parseInt(morceaux[1]) - 1, parseInt(morceaux[0]));
    }
    formatDateApi(date) {
        if (!date) {
            return null;
        }
        const jour = ('0' + date.getDate()).slice(-2);
        const mois = ('0' + (date.getMonth() + 1)).slice(-2);
        return jour + '-' + mois + '-' + date.getFullYear();
    }

    /*
     * Aperçu de l'échéancier de la cité : une ligne par échéance, une colonne par
     * catégorie. Si l'endpoint echeancier-cite n'est pas encore déployé, on retombe
     * sur l'aperçu catégorie par catégorie.
     */
    ouvrirApercu(rowData) {
        this.setState({
            apercuDialog : true,
            apercuCite : rowData,
            apercuIdCategorieChambre : null,
            apercu : null,
            apercuCategories : null,
            apercuLoading : true,
            listeCategorieChambre : [],
            categoriesChargees : false
        });

        this.parametrePaiementService.getEcheancierCite(rowData.idCite).then(data => {
            this.setState({apercuCategories : data, apercuLoading : false})
        })
        .catch(error => {
            console.log(error)
            this.setState({apercuLoading : false})
            this.chargerCategories(rowData)
        })
    }
    chargerCategories(rowData) {
        this.citeService.getCategorieChambreCite(rowData.idCite, rowData.nomCite).then(liste => {
            this.setState({listeCategorieChambre : liste, categoriesChargees : true})
        })
        .catch(error => {
            console.log(error)
            this.notify2("Impossible de charger les catégories de chambre de cette cité.")
            this.setState({listeCategorieChambre : [], categoriesChargees : true})
        })
    }
    hideApercuDialog() {
        this.setState({ apercuDialog : false, apercu : null, apercuCategories : null, apercuIdCategorieChambre : null });
    }
    chargerApercu(idCategorieChambre) {
        this.setState({ apercuIdCategorieChambre : idCategorieChambre, apercu : null, apercuLoading : true });
        this.parametrePaiementService.getApercuEcheancier(this.state.apercuCite.idCite, idCategorieChambre)
            .then(data => { this.setState({ apercu : data, apercuLoading : false }) })
            .catch(error => {
                console.log(error);
                this.notify2("Aperçu indisponible : vérifiez que la catégorie a un prix défini.");
                this.setState({ apercuLoading : false });
            })
    }

    /*
     * Échéances actuellement affichées, quelle que soit la source de l'aperçu
     * (tableau de la cité ou aperçu d'une seule catégorie).
     */
    getEcheancesAffichees() {
        if (this.state.apercuCategories) {
            return this.state.apercuCategories.echeances || [];
        }
        if (this.state.apercu) {
            return this.state.apercu.echeances || [];
        }
        return [];
    }
    getIdParametreApercu() {
        if (this.state.apercuCategories && this.state.apercuCategories.idParametrePaiementCite) {
            return this.state.apercuCategories.idParametrePaiementCite;
        }
        if (this.state.apercu && this.state.apercu.idParametrePaiementCite) {
            return this.state.apercu.idParametrePaiementCite;
        }
        return this.state.apercuCite ? this.state.apercuCite.idParametrePaiementCite : null;
    }
    ouvrirEditionDates() {
        const datesLimites = this.getEcheancesAffichees().map(echeance => ({
            ordre : echeance.ordre,
            typeEcheance : echeance.typeEcheance,
            nombreMois : echeance.nombreMois,
            dateLimite : this.parseDateApi(echeance.dateLimite)
        }));
        this.setState({ datesDialog : true, datesLimites : datesLimites });
    }
    onDateLimiteChange(ordre, valeur) {
        this.setState({
            datesLimites : this.state.datesLimites.map(ligne =>
                ligne.ordre === ordre ? { ...ligne, dateLimite : valeur } : ligne
            )
        });
    }
    enregistrerDatesLimites() {
        const idParametre = this.getIdParametreApercu();
        if (!idParametre) {
            this.notify2("Paramétrage de la cité introuvable.");
            return;
        }
        // on n'envoie que l'ordre et la date : le reste n'est là que pour l'affichage
        const datesLimites = this.state.datesLimites.map(ligne => ({
            ordre : ligne.ordre,
            dateLimite : this.formatDateApi(ligne.dateLimite)
        }));

        this.setState({ enregistrementDates : true });
        this.parametrePaiementService.updateDatesLimites(idParametre, datesLimites).then(data => {
            this.notify();
            this.setState({ datesDialog : false, enregistrementDates : false });
            this.ouvrirApercu(this.state.apercuCite);
        })
        .catch(error => {
            console.log(error);
            this.notify2(messageErreur(error, {
                404 : "La modification des dates limites n'est pas encore disponible côté serveur."
            }));
            this.setState({ enregistrementDates : false });
        })
    }

    moisRestantBodyTemplate(rowData) {
        if (!rowData.parametre) {
            return <span style={{color : "red"}}>Non paramétré</span>;
        }
        const reste = rowData.resteAPayerMois !== undefined && rowData.resteAPayerMois !== null
            ? rowData.resteAPayerMois
            : this.getResteAPayerMois(rowData);
        return <span>{reste} mois</span>;
    }
    moisBodyTemplate(rowData, champ, suffixe) {
        if (!rowData.parametre) {
            return <span>-</span>;
        }
        return <span>{rowData[champ]} {suffixe}</span>;
    }
    actionBodyTemplate(rowData) {
        return (
            <React.Fragment>
                <Button type="button" icon="pi pi-pencil" className="p-button-warning" onClick={() => this.editParametrePaiement(rowData)} style={{marginRight: '.5em'}}/>
                <Button type="button" icon="pi pi-eye" className="p-button-info" disabled={!rowData.parametre} onClick={() => this.ouvrirApercu(rowData)} />
            </React.Fragment>
        );
    }
    notify = () => toast.success('Opération réuçit!', {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    notify2 = (message) => toast.error(message || "Echec de l'opération !", {
            position: "top-right",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        })
    loadingSpinner = ( type, color) => (
        <ReactLoading type={type} color={color} height={200} width={50} />
    )

    formatMontant = (valeur) => Number(valeur).toLocaleString('fr-FR') + " FCFA";

    /* Montants qui découlent du paramétrage, pour chaque catégorie de chambre de la cité. */
    renderRecapitulatif() {
        const parametrePaiement = this.state.parametrePaiement;
        const reste = this.getResteAPayerMois(parametrePaiement);
        if (this.getErreurValidation() || reste === null) {
            return null;
        }
        const caution = parseInt(parametrePaiement.cautionMois);
        const premierVersement = parseInt(parametrePaiement.loyerPremierVersementMois);
        const echeance = reste === 0 ? 0 : parseInt(parametrePaiement.nombreEcheancesReste);

        return (
            <div className="p-field">
                <label>Montants correspondants</label>
                <table style={{width : "100%", fontSize : "0.85em", borderCollapse : "collapse"}}>
                    <thead>
                        <tr style={{borderBottom : "1px solid #ccc", textAlign : "left"}}>
                            <th>Catégorie</th>
                            <th style={{textAlign : "right"}}>1er versement</th>
                            <th style={{textAlign : "right"}}>Reste</th>
                            <th style={{textAlign : "right"}}>Par échéance</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.listeCategorieChambre.map(categorie => {
                            const prix = parseInt(categorie.montantChambre);
                            if (isNaN(prix)) {
                                return (
                                    <tr key={categorie.idCategorieChambre}>
                                        <td>{categorie.libelleCategorieChambre}</td>
                                        <td colSpan="3" style={{textAlign : "right", color : "red"}}>prix non défini</td>
                                    </tr>
                                );
                            }
                            const totalReste = reste * prix;
                            return (
                                <tr key={categorie.idCategorieChambre}>
                                    <td>{categorie.libelleCategorieChambre}</td>
                                    <td style={{textAlign : "right"}}>{this.formatMontant((caution + premierVersement) * prix)}</td>
                                    <td style={{textAlign : "right"}}>{this.formatMontant(totalReste)}</td>
                                    <td style={{textAlign : "right"}}>{echeance ? this.formatMontant(Math.ceil(totalReste / echeance)) : "-"}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <small>1er versement = {caution} mois de caution + {premierVersement} mois de loyer.
                    {reste > 0
                        ? " Reste " + reste + " mois, en " + echeance + " échéance(s)."
                        : " Aucun reste à payer."}
                </small>
            </div>
        );
    }

    formatDateAffichage(date) {
        return date ? String(date).replace(/-/g, '/') : '';
    }

    /*
     * Tableau de la cité : lignes = échéances, colonnes = catégories de chambre.
     * Les catégories sans montant défini ne sont pas renvoyées par le serveur.
     */
    renderApercuCite() {
        const apercu = this.state.apercuCategories;
        const categories = apercu.categories || [];
        const echeances = apercu.echeances || [];
        if (!categories.length) {
            return <small style={{color : "red"}}>Aucune catégorie de chambre de cette cité n'a de prix défini.</small>;
        }
        const montantDe = (echeance, idCategorieChambre) => {
            const montant = (echeance.montants || []).find(m => m.idCategorieChambre === idCategorieChambre);
            return montant ? this.formatMontant(montant.montant) : '-';
        };
        return (
            <div style={{overflowX : "auto"}}>
                {apercu.dateDebutOccupation &&
                    <p style={{marginBottom : "5px"}}>Début d'occupation : <b>{this.formatDateAffichage(apercu.dateDebutOccupation)}</b></p>}
                <table style={{width : "100%", fontSize : "0.9em", borderCollapse : "collapse"}}>
                    <thead>
                        <tr style={{borderBottom : "1px solid #ccc", textAlign : "left"}}>
                            <th>N°</th>
                            <th>Échéance</th>
                            <th style={{textAlign : "right"}}>Mois</th>
                            <th>Date limite</th>
                            {categories.map(categorie => (
                                <th key={categorie.idCategorieChambre} style={{textAlign : "right"}}>
                                    {categorie.libelleCategorieChambre}<br/>
                                    <small>{this.formatMontant(categorie.montantMensuel)}/mois</small>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {echeances.map(echeance => (
                            <tr key={echeance.ordre}>
                                <td>{echeance.ordre}</td>
                                <td>{this.libelleTypeEcheance(echeance.typeEcheance)}</td>
                                <td style={{textAlign : "right"}}>{echeance.nombreMois}</td>
                                <td>{this.formatDateAffichage(echeance.dateLimite)}</td>
                                {categories.map(categorie => (
                                    <td key={categorie.idCategorieChambre} style={{textAlign : "right"}}>
                                        {montantDe(echeance, categorie.idCategorieChambre)}
                                    </td>
                                ))}
                            </tr>
                        ))}
                        <tr style={{borderTop : "1px solid #ccc", fontWeight : "bold"}}>
                            <td colSpan="4">Total</td>
                            {categories.map(categorie => (
                                <td key={categorie.idCategorieChambre} style={{textAlign : "right"}}>
                                    {this.formatMontant(categorie.montantTotal)}
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    /* Échéancier tel que le serveur le calculera réellement. */
    renderApercu() {
        if (this.state.apercuLoading) {
            return (
                <div className="p-grid">
                    <div className="p-col-6"></div>
                    <div className="p-col-6">{this.loadingSpinner("spin","black")}</div>
                </div>
            );
        }
        if (this.state.apercuCategories) {
            return this.renderApercuCite();
        }
        const apercu = this.state.apercu;
        if (!apercu) {
            return <small>Choisissez une catégorie de chambre pour voir le détail des échéances.</small>;
        }
        const echeances = apercu.echeances || [];
        const total = echeances.reduce((somme, echeance) => somme + Number(echeance.montant), 0);
        return (
            <div>
                <p style={{marginBottom : "5px"}}>Loyer mensuel : <b>{this.formatMontant(apercu.montantMensuel)}</b></p>
                <table style={{width : "100%", fontSize : "0.9em", borderCollapse : "collapse"}}>
                    <thead>
                        <tr style={{borderBottom : "1px solid #ccc", textAlign : "left"}}>
                            <th>N°</th>
                            <th>Type</th>
                            <th style={{textAlign : "right"}}>Mois</th>
                            <th>Date limite</th>
                            <th style={{textAlign : "right"}}>Montant</th>
                        </tr>
                    </thead>
                    <tbody>
                        {echeances.map(echeance => (
                            <tr key={echeance.ordre}>
                                <td>{echeance.ordre}</td>
                                <td>{this.libelleTypeEcheance(echeance.typeEcheance)}</td>
                                <td style={{textAlign : "right"}}>{echeance.nombreMois}</td>
                                <td>{this.formatDateAffichage(echeance.dateLimite)}</td>
                                <td style={{textAlign : "right"}}>{this.formatMontant(echeance.montant)}</td>
                            </tr>
                        ))}
                        <tr style={{borderTop : "1px solid #ccc", fontWeight : "bold"}}>
                            <td colSpan="4">Total</td>
                            <td style={{textAlign : "right"}}>{this.formatMontant(total)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
    libelleTypeEcheance(typeEcheance) {
        if (typeEcheance === "CAUTION") return "Caution";
        if (typeEcheance === "PREMIER_VERSEMENT") return "1er versement";
        if (typeEcheance === "RESTE") return "Reste";
        return typeEcheance;
    }

    render() {
        const parametrePaiement = this.state.parametrePaiement;
        const reste = this.getResteAPayerMois(parametrePaiement);
        const erreur = this.getErreurValidation();
        let actionHeader = <Button type="button" icon="pi pi-cog"/>;
        const header = (
            <div className="table-header p-col-2">
                <span className="p-input-icon-left">
                    <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Recherche globale..." />
                </span>
            </div>
        );
        const parametrePaiementDialogFooter = (
            <React.Fragment>
                <Button label="Quitter" icon="pi pi-times" className="p-button-text" onClick={this.hideDialog} />
                <Button label="Enregistrer" icon="pi pi-check" className="p-button-text" disabled={this.state.enregistrement} onClick={this.saveParametrePaiement} />
            </React.Fragment>
        );
        const apercuDialogFooter = (
            <React.Fragment>
                <Button label="Dates limites" icon="pi pi-calendar" className="p-button-text"
                        disabled={!this.getEcheancesAffichees().length} onClick={this.ouvrirEditionDates} />
                <Button label="Fermer" icon="pi pi-times" className="p-button-text" onClick={this.hideApercuDialog} />
            </React.Fragment>
        );
        const datesDialogFooter = (
            <React.Fragment>
                <Button label="Quitter" icon="pi pi-times" className="p-button-text" onClick={() => this.setState({datesDialog : false})} />
                <Button label="Enregistrer" icon="pi pi-check" className="p-button-text"
                        disabled={this.state.enregistrementDates} onClick={this.enregistrerDatesLimites} />
            </React.Fragment>
        );

        return (
            <div className="p-grid">
                <div className="p-col-12">
                    <div className="p-grid">
                        <div className="p-col-3">
                            <Dropdown optionLabel="libelleAnnee" optionValue="idAnnee" value={this.state.idAnneeFiltre}
                                      options={this.state.listeAnnee}
                                      onChange={(e) => this.setState({idAnneeFiltre : e.value}, this.loadDonnees)}
                                      placeholder="Année académique"/>
                        </div>
                        <div className="p-col-2">
                            <Button label="Rafraichir" icon="pi pi-refresh" className="" onClick={this.loadDonnees} />
                        </div>
                    </div>

                    <div className="card card-w-title datatable-demo">
                    <ToastContainer
                        position="top-right"
                        autoClose={2000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                    <ToastContainer />
                        {header}
                        {this.state.loading ?
                        <div className="p-grid">
                            <div className="p-col-6" ></div>
                            <div className="p-col-6" >
                                {this.loadingSpinner("spin","black")}
                            </div>
                        </div>
                        :
                        <DataTable  ref={(el) => this.dt = el} value={this.getLignes()} selectionMode="single" header="Paiement du loyer par cité" paginator={true} rows={10}
                              globalFilter={this.state.globalFilter} filterMatchMode="contains" responsive={true} selection={this.state.dataTableSelection1} onSelectionChange={event => this.setState({dataTableSelection1: event.value})}>
                            <Column field="nomCite" header="Cité" filterMatchMode="contains" sortable={true} filter={true} filterPlaceholder="rechercher cité"/>
                            <Column field="idAnnee" header="Année" body={(rowData) => <span>{rowData.parametre ? (rowData.idAnnee || '-') : '-'}</span>} sortable={true} style={{width : '7em'}}/>
                            <Column field="dureeOccupationMois" header="Durée d'occupation" body={(rowData) => this.moisBodyTemplate(rowData, 'dureeOccupationMois', 'mois')} sortable={true}/>
                            <Column field="cautionMois" header="Caution" body={(rowData) => this.moisBodyTemplate(rowData, 'cautionMois', 'mois')} sortable={true}/>
                            <Column field="loyerPremierVersementMois" header="Loyer 1er versement" body={(rowData) => this.moisBodyTemplate(rowData, 'loyerPremierVersementMois', 'mois')} sortable={true}/>
                            <Column header="Reste à payer" body={this.moisRestantBodyTemplate}/>
                            <Column field="nombreEcheancesReste" header="Échéances" body={(rowData) => this.moisBodyTemplate(rowData, 'nombreEcheancesReste', '')} sortable={true}/>
                            <Column field="dateDebutOccupation" header="Début occupation" body={(rowData) => <span>{rowData.parametre ? this.formatDateAffichage(rowData.dateDebutOccupation) : '-'}</span>}/>
                            <Column header={actionHeader} body={this.actionBodyTemplate} style={{textAlign:'center', width: '10em'}}/>
                        </DataTable>
                        }
                    </div>
                </div>

                <Dialog visible={this.state.parametrePaiementDialog} style={{ width: '550px' }} header="Paiement du loyer" modal className="p-fluid" footer={parametrePaiementDialogFooter} onHide={this.hideDialog}>
                    <div className="p-field">
                        <label htmlFor="nomCite">Cité</label>
                        <InputText id="nomCite" value={parametrePaiement.nomCite || ''} disabled />
                    </div>
                    <div className="p-field">
                        <label htmlFor="idAnnee">Année académique</label>
                        <Dropdown id="idAnnee" optionLabel="libelleAnnee" optionValue="idAnnee" value={parametrePaiement.idAnnee}
                                  options={this.state.listeAnnee} disabled={!!parametrePaiement.idParametrePaiementCite}
                                  onChange={(e) => this.setState({ parametrePaiement : { ...parametrePaiement, idAnnee : e.value } })}
                                  placeholder="Choisir une année"/>
                        <small>Le paramétrage vaut pour cette année ; une nouvelle année se reparamètre.</small>
                    </div>
                    <div className="p-field">
                        <label htmlFor="dureeOccupationMois">Durée d'occupation (mois)</label>
                        <InputText id="dureeOccupationMois" value={parametrePaiement.dureeOccupationMois} keyfilter="pint" onChange={(e) => this.onChampChange(e, 'dureeOccupationMois')} required autoFocus className={classNames({ 'p-invalid': this.state.submitted && !parametrePaiement.dureeOccupationMois })} />
                    </div>
                    <div className="p-field">
                        <label htmlFor="cautionMois">Caution (nombre de mois de loyer)</label>
                        <InputText id="cautionMois" value={parametrePaiement.cautionMois} keyfilter="pint" onChange={(e) => this.onChampChange(e, 'cautionMois')} required className={classNames({ 'p-invalid': this.state.submitted && parametrePaiement.cautionMois === '' })} />
                    </div>
                    <div className="p-field">
                        <label htmlFor="loyerPremierVersementMois">Loyer payé au 1er versement (mois)</label>
                        <InputText id="loyerPremierVersementMois" value={parametrePaiement.loyerPremierVersementMois} keyfilter="pint" onChange={(e) => this.onChampChange(e, 'loyerPremierVersementMois')} required className={classNames({ 'p-invalid': this.state.submitted && parametrePaiement.loyerPremierVersementMois === '' })} />
                    </div>
                    <div className="p-field">
                        <label htmlFor="resteAPayerMois">Reste à payer (mois)</label>
                        <InputText id="resteAPayerMois" value={reste === null ? '' : reste} disabled />
                        <small>Calculé : durée d'occupation - loyer du 1er versement.</small>
                    </div>
                    <div className="p-field">
                        <label htmlFor="nombreEcheancesReste">Nombre d'échéances pour le reste</label>
                        <InputText id="nombreEcheancesReste" value={reste === 0 ? 0 : parametrePaiement.nombreEcheancesReste} keyfilter="pint" disabled={reste === 0} onChange={(e) => this.onChampChange(e, 'nombreEcheancesReste')} required className={classNames({ 'p-invalid': this.state.submitted && reste !== 0 && !parametrePaiement.nombreEcheancesReste })} />
                    </div>
                    <div className="p-field">
                        <label htmlFor="dateDebutOccupation">Début d'occupation</label>
                        <Calendar id="dateDebutOccupation" value={parametrePaiement.dateDebutOccupation} dateFormat="dd-mm-yy" showIcon={true} monthNavigator={true} yearNavigator={true} yearRange="2020:2035"
                                  onChange={(e) => this.setState({ parametrePaiement : { ...parametrePaiement, dateDebutOccupation : e.value } })} />
                        <small>Facultatif. Sert à calculer la date limite de chaque échéance ; sans elle, les échéances n'en ont pas.</small>
                    </div>
                    {this.state.submitted && erreur && <small className="p-invalid" style={{color : "red"}}>{erreur}</small>}
                    {this.renderRecapitulatif()}
                </Dialog>

                <Dialog visible={this.state.apercuDialog} style={{ width: this.state.apercuCategories ? '800px' : '550px' }} header={"Aperçu de l'échéancier" + (this.state.apercuCite ? " - " + this.state.apercuCite.nomCite : "")} modal className="p-fluid" footer={apercuDialogFooter} onHide={this.hideApercuDialog}>
                    {!this.state.apercuCategories && !this.state.apercuLoading &&
                    <div className="p-field">
                        <label htmlFor="apercuCategorie">Catégorie de chambre</label>
                        <Dropdown id="apercuCategorie" optionLabel="libelleCategorieChambre" optionValue="idCategorieChambre" value={this.state.apercuIdCategorieChambre}
                                  options={this.state.listeCategorieChambre} onChange={(e) => this.chargerApercu(e.value)} placeholder="Choisir une catégorie"/>
                        {this.state.categoriesChargees && !this.state.listeCategorieChambre.length &&
                            <small style={{color : "red"}}>Aucune catégorie de chambre n'est rattachée à cette cité.</small>}
                    </div>}
                    {this.renderApercu()}
                </Dialog>

                <Dialog visible={this.state.datesDialog} style={{ width: '550px' }} header={"Dates limites de paiement" + (this.state.apercuCite ? " - " + this.state.apercuCite.nomCite : "")} modal className="p-fluid" footer={datesDialogFooter} onHide={() => this.setState({datesDialog : false})}>
                    <p style={{marginTop : 0}}>
                        Ces dates valent pour toutes les catégories de chambre de la cité :
                        seuls les montants changent d'une catégorie à l'autre.
                    </p>
                    <table style={{width : "100%", borderCollapse : "collapse"}}>
                        <thead>
                            <tr style={{borderBottom : "1px solid #ccc", textAlign : "left"}}>
                                <th>N°</th>
                                <th>Échéance</th>
                                <th style={{textAlign : "right"}}>Mois</th>
                                <th style={{width : "11em"}}>Date limite</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.datesLimites.map(ligne => (
                                <tr key={ligne.ordre}>
                                    <td>{ligne.ordre}</td>
                                    <td>{this.libelleTypeEcheance(ligne.typeEcheance)}</td>
                                    <td style={{textAlign : "right"}}>{ligne.nombreMois}</td>
                                    <td style={{padding : "3px 0"}}>
                                        <Calendar value={ligne.dateLimite} dateFormat="dd-mm-yy" showIcon={true}
                                                  monthNavigator={true} yearNavigator={true} yearRange="2020:2035"
                                                  onChange={(e) => this.onDateLimiteChange(ligne.ordre, e.value)} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <small>Une date vide laisse l'échéance sans date limite.</small>
                </Dialog>
            </div>
        )
    }
}

export default ParametrePaiement
